module.exports = __webpack_public_path__ + "static/media/lock_open.a1e15133.svg";